export default __webpack_public_path__ + "static/media/23_SAUTER.3e6dc069.png";